/**
 * SAT Preview - lets the analysis and results sections render inside the
 * Shopify theme editor.
 *
 * Both pages normally bail to the landing page when there is no assessment in
 * sessionStorage, which is correct on the storefront but makes the sections
 * impossible to configure. In design mode we seed representative data instead,
 * shaped exactly like a real /report response so the same code paths run.
 */
(function (global) {
  "use strict";

  var PLACEHOLDER =
    "https://cdn.shopify.com/s/files/1/0888/8057/8807/files/Dark_shimmer.png?v=1785825233";

  function isDesignMode() {
    return !!(global.Shopify && global.Shopify.designMode);
  }

  function imageUrls() {
    return { raw_image: PLACEHOLDER, analyzed_image: PLACEHOLDER };
  }

  function scores() {
    return {
      skin_type: "Oily",
      gender: "Female",
      overall_score: 78,
      concerns: [
        { name: "Dark Circles", score: 58, severity: "Moderate" },
        { name: "Open Pores", score: 75, severity: "Mild" },
        { name: "Pigmentation", score: 78, severity: "Mild" },
        { name: "Acne", score: 85, severity: "Mild" },
        { name: "Aging", score: 85, severity: "Mild" },
        { name: "Acne Scars", score: 88, severity: "Mild" },
      ],
    };
  }

  function report() {
    var s = scores();
    return {
      assessmentId: 0,
      gender: s.gender,
      skin_type: s.skin_type,
      overall_score: s.overall_score,
      raw_image: PLACEHOLDER,
      analyzed_image: PLACEHOLDER,
      user_selected_concerns: ["Dark Circles", "Open Pores"],
      concerns: s.concerns,
      products: [],
    };
  }

  global.SATPreview = {
    isDesignMode: isDesignMode,
    imageUrls: imageUrls,
    scores: scores,
    report: report,

    /** Fill sessionStorage so the analysis page can render its steps. */
    seed: function () {
      if (!global.SATState) return;
      if (!global.SATState.getImageUrls())
        global.SATState.setImageUrls(imageUrls());
      if (!global.SATState.getScores()) global.SATState.setScores(scores());
    },
  };
})(window);
